module.exports = __webpack_public_path__ + "static/media/close-img-white.57d14016.svg";